import Mock from '../mock';

// const JWT_SECRET = 'jwt_secret_key';
// const JWT_VALIDITY = '7 days';

const userList = [
  {
    id: 1,
    role_id: 1,
    role_name: 'Super Admin',
    role_code: 'SAQ',
    first_name: 'Shikha',
    last_name: 'Chopra',
    mobile: '9876543210',
    name: 'Shikha Chopra',
    username: 'super_admin',
    password: '',
    email: 'shikha@indianredcross.org',
    avatar: '/assets/images/face-6.jpg',
    age: 25,
    state_id: '',
    district_id: '',
    module_access: [
      {
        module_access_id: 1,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 2,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 4,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      }
    ]
  },
  {
    id: 2,
    role_id: 2,
    role_name: 'NHQ Admin',
    role_code: 'NA',
    name: 'R K Jain',
    first_name: 'R K',
    last_name: 'Jain',
    mobile: '9876543211',
    password: '',
    username: 'rk_jain',
    email: 'rkjain@indianredcross.org',
    avatar: '/assets/images/face-6.jpg',
    age: 25,
    state_id: '',
    district_id: '',
    module_access: [
      {
        module_access_id: 1,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 2,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 4,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 4,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      }
    ]
  },
  {
    id: 3,
    role_id: 3,
    role_name: 'State Admin',
    role_code: 'SA',
    name: 'Jason Alexander',
    first_name: 'Jason',
    last_name: 'Alexander',
    mobile: '9876543212',
    password: '',
    username: 'jason_alexander',
    email: 'jason@indianredcross.org',
    avatar: '/assets/images/face-6.jpg',
    age: 25,
    state_id: '',
    district_id: '',
    module_access: [
      {
        module_access_id: 1,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 2,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 3,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 4,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      }
      // {
      //   module_access_id: 4,
      //   is_module_access: '',
      //   is_create: true,
      //   is_read: true,
      //   is_update: true,
      //   is_delete: true
      // },
      // {
      //   module_access_id: 5,
      //   is_module_access: '',
      //   is_create: true,
      //   is_read: true,
      //   is_update: true,
      //   is_delete: true
      // },
      // {
      //   module_access_id: 6,
      //   is_module_access: '',
      //   is_create: true,
      //   is_read: true,
      //   is_update: true,
      //   is_delete: true
      // },
      // {
      //   module_access_id: 7,
      //   is_module_access: '',
      //   is_create: true,
      //   is_read: true,
      //   is_update: true,
      //   is_delete: true
      // }
    ]
  },
  {
    id: 4,
    role_id: 4,
    role_name: 'District Admin',
    role_code: 'DA',
    name: 'Jason Alexander',
    first_name: 'Jason',
    last_name: 'Alexander',
    mobile: '9876543213',
    password: '',
    username: 'jason_alexander',
    email: 'district@indianredcross.org',
    avatar: '/assets/images/face-6.jpg',
    age: 25,
    state_id: '',
    district_id: '',
    module_access: [
      {
        module_access_id: 1,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 2,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 3,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 4,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 5,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 6,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 7,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 8,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      },
      {
        module_access_id: 9,
        is_module_access: '',
        is_create: true,
        is_read: true,
        is_update: true,
        is_delete: true
      }
    ]
  }
];

// FOLLOWING CODES ARE MOCK SERVER IMPLEMENTATION
// YOU NEED TO BUILD YOUR OWN SERVER
// IF YOU NEED HELP ABOUT SERVER SIDE IMPLEMENTATION
// CONTACT US AT support@ui-lib.com

Mock.onPost('/api/auth/login').reply(async (config) => {
  try {
    const { email } = JSON.parse(config.data);
    const user = userList.find((u) => u.email === email);
    if (!user) return [400, { message: 'Invalid email or password' }];

    const payload = { user: user };
    return [200, payload];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

Mock.onPost('/api/auth/register').reply((config) => {
  try {
    const { email, username } = JSON.parse(config.data);
    const user = userList.find((u) => u.email === email);

    if (user) return [400, { message: 'User already exists!' }];

    const newUser = {
      id: 2,
      role: 'GUEST',
      name: 'Unknown',
      age: 25,
      email: email,
      username: username,
      avatar: '/assets/images/face-6.jpg'
    };

    userList.push(newUser);

    const payload = { user: { ...newUser } };
    return [200, payload];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

Mock.onGet('/api/auth/profile').reply((config) => {
  try {
    console.log('config---->', config);
    // const { Authorization } = config.headers;
    // if (!Authorization) {
    //   return [401, { message: 'Invalid Authorization token' }];
    // }

    // const accessToken = Authorization.split(' ')[1];
    // const { userId } = jwt.verify(accessToken, JWT_SECRET);
    // const user = userList.find((u) => u.id === userId);

    // if (!user) {
    //   return [401, { message: 'Invalid authorization token' }];
    // }

    const payload = { user: userList[0] };
    return [200, payload];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});
